import moment from 'moment';
import ReactDatePicker from 'react-datepicker';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { InputErrorMessage } from './InputErrorMessage';

import 'react-datepicker/dist/react-datepicker.css';

const Wrapper = styled.div``;

export const DateInput = ({
    name,
    label = undefined,
    rules = {},
    className = undefined,
    inputClassName = undefined,
    helperText = undefined,
    ...props
}) => {
    const { control } = useFormContext();

    const parseValue = (value) => {
        if (value === undefined) return undefined;

        const date = moment(value);
        if (date.isValid()) return date.hours(date.utcOffset() / 60).toDate();

        return undefined;
    };
    return (
        <Wrapper className={'form-group' + (className ? ' ' + className : '')} {...props}>
            {label && <label>{label + (rules.required ? ' *' : '')}</label>}
            {helperText && <small className="form-text text-muted">{helperText}</small>}
            <Controller
                control={control}
                rules={rules}
                name={name}
                render={({ field: { value, onChange, onBlur }, fieldState: { invalid } }) => (
                    <>
                        <ReactDatePicker
                            selected={parseValue(value)}
                            onChange={(date) => onChange(parseValue(date))} // fix utc time offset in date picker
                            onBlur={onBlur}
                            showYearDropdown
                            dateFormat="dd.MM.yyyy"
                            placeholderText="TT.MM.JJJJ"
                            className={`form-control ${invalid ? 'is-invalid' : ''}${
                                inputClassName ? ' ' + inputClassName : ''
                            }`}
                            wrapperClassName="form-control"
                        />
                        <InputErrorMessage name={name} />
                    </>
                )}
            />
        </Wrapper>
    );
};
